import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "./lib/analytics";
import { initMonitoring } from "./lib/monitoring";

initMonitoring();
initAnalytics();

const rootEl = document.getElementById("root")!;
if (rootEl.firstElementChild) {
  hydrateRoot(rootEl, <App />);
} else {
  createRoot(rootEl).render(<App />);
}
